import './ytPageHeader.scss'

export default {
    name: 'YtPageHeader',

    props: {
        // 返回页面名称 或者 操作名称
        title: {
            type: String,
            default: '返回'
        },

        // 当前页面名称
        content: {
            type: String,
            default: ''
        }
    },

    render() {
        return (
            <div class='yt-page-header'>
                <div class='header__left' onClick={() => this.$emit('back')}>
                    <i class='el-icon-arrow-left' />
                    <div class='header-title'>
                        {(this.title && !this.$slots.title) && this.title}
                        {(this.title && this.$slots.title) && (!this.title && this.$slots.title) && this.$slots.title}
                    </div>
                </div>
                <span class='header__separator' />
                <div class='header__content'>
                    {(this.content && !this.$slots.content) && this.content}
                    {(this.content && this.$slots.content) && (!this.content && this.$slots.content) && this.$slots.content}
                </div>
            </div>
        )
    }
}
